/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CodeAndLabel
 */
export interface CodeAndLabel {
    /**
     * 
     * @type {string}
     * @memberof CodeAndLabel
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CodeAndLabel
     */
    label?: string | null;
}

export function CodeAndLabelFromJSON(json: any): CodeAndLabel {
    return CodeAndLabelFromJSONTyped(json, false);
}

export function CodeAndLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeAndLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function CodeAndLabelToJSON(value?: CodeAndLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'label': value.label,
    };
}


